import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { resumeIncompletedDownloads } from '../../utils';
export const useResumeIncompletedDownloads = () => {
    const client = useQueryClient();
    useEffect(() => {
        resumeIncompletedDownloads(client);
    }, [client]);
};
//# sourceMappingURL=useResumeIncompletedDownloads.js.map